import React, { useState, useRef } from 'react';

function RegistrationForm() {
    const [formData, setFormData] = useState({
        firstName: '', lastName: '', email: '', phoneNumber: '', password: '', state: '', city: '', position: ''
    });
    const [selectedFile, setSelectedFile] = useState(null);
    const [message, setMessage] = useState('');
    const [isError, setIsError] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const fileInputRef = useRef(null);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevState => ({ ...prevState, [name]: value }));
    };

    const handleFileChange = (e) => {
        setSelectedFile(e.target.files[0]);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        setMessage('');
        setIsError(false);

        // Use FormData to handle both text and file data
        const submissionData = new FormData();
        for (const key in formData) {
            submissionData.append(key, formData[key]);
        }
        if (selectedFile) {
            submissionData.append('profilePhoto', selectedFile);
        }

        try {
            const response = await fetch('https://members.abssvss.com/members_api/register_user.php', {
                method: 'POST',
                // No 'Content-Type' header needed for FormData; browser sets it
                body: submissionData,
            });

            const result = await response.json();
            if (!response.ok) {
                throw new Error(result.message || 'An error occurred.');
            }

            setMessage(result.message);
            setIsError(false);
            // Reset form on success
            setFormData({ firstName: '', lastName: '', email: '', phoneNumber: '', password: '', state: '', city: '', position: '' });
            setSelectedFile(null);
            if (fileInputRef.current) {
                fileInputRef.current.value = '';
            }
        } catch (error) {
            setMessage(error.message);
            setIsError(true);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="bg-white p-8 rounded-lg shadow-lg w-full max-w-2xl border-t-4 border-brand-accent">
            <h2 className="text-3xl font-bold text-brand-primary text-center mb-6">Community Membership Registration</h2>
            <form onSubmit={handleSubmit} className="space-y-4">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <input type="text" name="firstName" value={formData.firstName} onChange={handleChange} placeholder="First Name" required className="p-3 bg-gray-50 text-gray-800 rounded-md border" />
                    <input type="text" name="lastName" value={formData.lastName} onChange={handleChange} placeholder="Last Name" required className="p-3 bg-gray-50 text-gray-800 rounded-md border" />
                </div>
                <input type="email" name="email" value={formData.email} onChange={handleChange} placeholder="Email Address" required className="w-full p-3 bg-gray-50 text-gray-800 rounded-md border" />
                <input type="tel" name="phoneNumber" value={formData.phoneNumber} onChange={handleChange} placeholder="Phone Number" required className="w-full p-3 bg-gray-50 text-gray-800 rounded-md border" />
                <input type="password" name="password" value={formData.password} onChange={handleChange} placeholder="Password" required className="w-full p-3 bg-gray-50 text-gray-800 rounded-md border" />
                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Profile Picture (JPG/PNG, max 2MB)</label>
                    <input type="file" name="profilePhoto" onChange={handleFileChange} ref={fileInputRef} accept="image/jpeg, image/png" className="block w-full text-sm text-slate-500 file:mr-4 file:py-2 file:px-4 file:rounded-full file:border-0 file:text-sm file:font-semibold file:bg-violet-50 file:text-violet-700 hover:file:bg-violet-100"/>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <input type="text" name="state" value={formData.state} onChange={handleChange} placeholder="State" required className="p-3 bg-gray-50 text-gray-800 rounded-md border" />
                    <input type="text" name="city" value={formData.city} onChange={handleChange} placeholder="City" required className="p-3 bg-gray-50 text-gray-800 rounded-md border" />
                </div>
                <input type="text" name="position" value={formData.position} onChange={handleChange} placeholder="Position (Optional)" className="w-full p-3 bg-gray-50 text-gray-800 rounded-md border" />
                <button type="submit" disabled={isLoading} className="w-full p-3 bg-brand-accent hover:bg-orange-500 rounded-md font-bold text-white transition-colors disabled:bg-gray-400">
                    {isLoading ? 'Submitting...' : 'Register'}
                </button>
            </form>
            {message && (
                <div className={`mt-4 text-center p-3 rounded-md ${isError ? 'bg-red-100 text-red-700' : 'bg-green-100 text-green-700'}`}>
                    {message}
                </div>
            )}
        </div>
    );
}

export default RegistrationForm;

